export default __webpack_public_path__ + "static/media/alert-icon.b14f51b3.svg";